import theme from "./theme";
export default function mode(values) {
  return theme("mode", values);
}
//# sourceMappingURL=mode.js.map